module.exports = __webpack_public_path__ + "img/stage-6-animated.f51a8c60.png";